import { concatRoutes } from '/imports/modules/Routing';
import { manageQuizRouter } from '../manage/presentation/router';
import { solveQuizRouter } from '../solve/presentation/router';

export const quizRouter = concatRoutes([manageQuizRouter, solveQuizRouter]);
